import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot from react-dom/client
import App from './App';
import './index.css';
import './assets/vendor/css/core.css'
import './assets/vendor/css/theme-default.css'

// Get the root element
const container = document.getElementById('root');

// Create a root
const root = createRoot(container);

// Render the application
root.render(
  <App />
);
